import React from 'react';
import '../css/Navbar.css';

function Navbar() {
  return (
    <header className="navbar">
      <a className="navbar-logo" href="#top" aria-label="Aevolt Everflow">
        Aevolt Energy
      </a>

      <nav className="navbar-links">
        <a href="#overview">Aevolt Everflow</a>
        <a href="#backup">Backup</a>
        {/* Future use: <a href="#control">App</a> */}
        <a href="#specs">Specs</a>
      </nav>

      <nav className="navbar-actions">
        {/* Future use: <a href="#order">Order</a> */}
        <a href="#order">Systems</a>
      </nav>
    </header>
  );
}

export default Navbar;
